export const GetData = 'GetData'
export const SetData = 'SetData'
export const SetLogin = 'SetLogin'
export const GetLogin = 'GetLogin'